import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTabs } from "../../../../../components";
import { Platform, WinLoss } from "./components";
import styles from "./style.module.scss";
const ComissionStatement = () => {
  const { t } = useTranslation();
  // const { levels } = useComission();
  const [activeTab, setActiveTab] = useState("win_loss");
  const tabItems = [
    {
      key: "win_loss",
      title: t("comission.tab.winloss"),
      component: <WinLoss />,
      destroyOnClose: true,
    },
    {
      key: "platform",
      title: t("comission.tab.platform"),
      component: <Platform />,
      destroyOnClose: true,
    },
    // {
    //   key: "promotion",
    //   title: t("comission.tab.promotion"),
    //   component: <Promotion />,
    //   destroyOnClose: true,
    // },
  ];

  const [tabs, setTabs] = useState(tabItems);

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  // useEffect(() => {
  //   setTabs([...tabItems, ...levels]);
  // }, [levels]);

  return (
    <div className={styles.container}>
      <CustomTabs activeKey={activeTab} onTabChange={onTabChange} tabItems={[...tabs]} />
    </div>
  );
};

export default ComissionStatement;
